import { More, DocumentText } from "iconsax-react";
import { Dropdown, Alert, Button } from "react-bootstrap";
import { useState } from "react";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../../components/Tabella/ChipFilter";

// Valori del filtro a chip, come compaiono nella lista.
const STATO_OPTIONS = ['In attesa', 'Non accettato'];

export const ListaAbilitazioneMaestri = () => {

    // Chip a scelta multipla: all'inizio tutti accesi
    const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

    const data_column = [

        {
            Header: 'Data richiesta',
            Footer: 'Data richiesta',
            accessor: 'data-richiesta',
            disableGlobalFilter: true,
        },
        {
            Header: 'Nome e Cognome',
            Footer: 'Nome e Cognome',
            accessor: 'nome-e-cognome',
        },
        {
            Header: 'Sport',
            Footer: 'Sport',
            accessor: 'sport',
        },
        {
            Header: 'Tesserino',
            Footer: 'Tesserino',
            accessor: 'tesserino',
            Cell: ({ value }) => {
                return (
                    <Button variant="dark light" size="xs" >
                        <span className="me-2"><DocumentText size="24" variant="Bulk" /></span>
                        {value}
                    </Button>
                );
            },
            disableFilters: true,
            disableGlobalFilter: true,
        },
        {
            Header: 'Stato richiesta',
            Footer: 'Stato richiesta',
            accessor: 'stato-richiesta',
            Cell: ({ value }) => {
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${value.class}`}></i>
                        {value.label}
                    </div>
                );
            },
            disableFilters: true,
            disableGlobalFilter: true,
        },
        {
            Header: 'Azione',
            Footer: 'Azione',
            accessor: 'azione',
            Cell: ({ value }) => {
                return (
                    <Dropdown>
                        <Dropdown.Toggle
                            className="btn-primary light sharp i-false btn-action"
                        >
                            <More />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item>Edit</Dropdown.Item>
                            <Dropdown.Item>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                )
            },
            disableFilters: true,
            disableGlobalFilter: true,
        },
    ];

    const data_json = [
        {
            "data-richiesta": "12 Marzo 2024",
            "nome-e-cognome": "Loredana Bassi",
            "email": "loredana@mail.com",
            "sport": "Calcio, Tennis, Nuoto",
            "stato-richiesta": {
                "label": "In attesa",
                "class": "text-warning"
            },
            "tesserino": "Tesserino tennis.pdf",
        },
        {
            "data-richiesta": "12 Marzo 2024",
            "nome-e-cognome": "Loredana Bassi",
            "email": "loredana@mail.com",
            "sport": "Calcio, Tennis, Nuoto",
            "stato-richiesta": {
                "label": "Non accettato",
                "class": "text-danger"
            },
            "tesserino": "Tesserino tennis.pdf",
        }
    ];

    // data_json e' un elenco d'esempio scritto qui dentro: si filtra a ogni render.
    const filteredData = data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row['stato-richiesta']?.label));

    return (
        <>
            <TabellaLista
                cardTitle={'Abilitazioni maestri'}
                pageList={true}
                hasSearch={true}
                searchPlaceholder={'Cerca per nome o sport'}
                hasFilter={false}
                filterControl={
                    <div className="sid-chip-filters">
                        <ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
                    </div>
                }
                hasAddMore={false}
                data_column={data_column}
                data_json={filteredData}
            />

            <Alert variant="danger">
                <Alert.Heading>Attenzione</Alert.Heading>
                <p>
                    La lista è in fase di creazione.<br />
                    Le "Azioni" non sono definitive
                </p>
            </Alert>
        </>
    )

}
export default ListaAbilitazioneMaestri;